import { Button, CircularProgress, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FC, Fragment } from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { FormProps } from 'shared/interfaces/IModalForm';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

interface IPetFormProps {
  assetsPropsForm: FormProps<string>;
  onSave?: VoidFunction;
  disableSaveButton?: boolean;
}

interface IAutocompleteFormProps {
  form: any;
}

const AutocompleteForm: FC<IAutocompleteFormProps> = ({ form }) => {
  const getOptionLabel = (option: any) => (form?.isStringForm ? `${option}` : option?.name);
  const getOptionSelected = (option: any, value: any) =>
    form?.isStringForm ? option === value : option?.id === value?.id;

  return (
    <Fragment>
      <CustomTypography color="mainGray" fontSize={14}>
        {form.name}
      </CustomTypography>

      <Autocomplete
        value={form.value}
        noOptionsText={form?.noOptionText || 'No Options'}
        popupIcon={form?.isLoading ? <CircularProgress size={12} style={{ marginTop: 5 }} /> : <ArrowDropDownIcon />}
        options={form?.list}
        getOptionLabel={getOptionLabel}
        getOptionSelected={getOptionSelected}
        onInputChange={(event, newInputValue) => {
          if (form?.name === 'Age') {
            form?.handleInputChange?.(newInputValue);
          }
        }}
        onChange={(event, newValue) => form.handleOnChange(newValue)}
        disabled={form?.disable}
        freeSolo={form?.name === 'Age'}
        renderInput={(params) => (
          <TextField
            placeholder={form?.placeholder || 'Select'}
            {...params}
            variant="outlined"
            type={form?.name === 'Age' ? 'number' : undefined}
            inputProps={{
              ...params.inputProps,
              readOnly: form?.readOnly,
            }}
          />
        )}
      />
    </Fragment>
  );
};

const AssetsPropsForm: FC<IPetFormProps> = ({ assetsPropsForm, onSave, disableSaveButton }) => {
  return (
    <Grid container>
      {assetsPropsForm?.stringForm?.map((form, index) => {
        return (
          <Fragment key={index}>
            <Grid item xs={12}>
              <AutocompleteForm form={{ ...form, isStringForm: true }} />
            </Grid>
          </Fragment>
        );
      })}
      <Grid item xs={12} style={{ marginTop: 5 }}>
        <Button
          onClick={onSave}
          disabled={disableSaveButton}
          variant="contained"
          color="primary"
          fullWidth
          size="medium"
          style={{ height: '50px', fontSize: 16 }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};

export default AssetsPropsForm;
